module.exports = __webpack_public_path__ + "static/4-ff0f013713c9d0588728354a303694fa.png";